import { fromPairs } from 'lodash';
import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { ProviderProduct } from '@upstart/harmony/lib/legos/penTypes';

// Online Form Pack Groups
export const FINANCE_TYPE_GROUP = 'financeType';
export const CONDITION_AND_TRADE_GROUP = 'conditionAndTrade';
export const PROTECTION_PLANS_GROUP = 'protectionPlans';

export const PROTECTION_PLANS_DESCRIPTION =
  'Please note, these forms will only be shown to customers purchasing this Protection Plan product.';

// Combines all previous objects
export const ONLINE_FORM_PACK_LOOKUP = {
  'cash-purchase': {
    name: 'Cash Purchase',
    group: FINANCE_TYPE_GROUP,
    description:
      'Please note, these forms will only be shown to customers purchasing in cash.',
  },
  'lease-purchase': {
    name: 'Lease Purchase',
    group: FINANCE_TYPE_GROUP,
    description:
      'Please note, these forms will only be shown to customers leasing a vehicle.',
  },
  'finance-purchase': {
    name: 'Finance Purchase',
    group: FINANCE_TYPE_GROUP,
    description:
      'Please note, these forms will only be shown to customers financing a vehicle.',
  },
  'new-car-trade-in': {
    name: 'New Car With Trade In',
    group: CONDITION_AND_TRADE_GROUP,
    description:
      'Please note, these forms will only be shown to customers purchasing New Car with a trade-in applied.',
  },
  'new-car-no-trade': {
    name: 'New Car Without Trade In',
    group: CONDITION_AND_TRADE_GROUP,
    description:
      'Please note, these forms will only be shown to customers purchasing New Car without a trade-in.',
  },
  'used-car-trade-in': {
    name: 'Used Car With Trade In',
    group: CONDITION_AND_TRADE_GROUP,
    description:
      'Please note, these forms will only be shown to customers purchasing a Used Car with a trade-in applied.',
  },
  'used-car-no-trade': {
    name: 'Used Car Without Trade In',
    group: CONDITION_AND_TRADE_GROUP,
    description:
      'Please note, these forms will only be shown to customers purchasing a Used Car without a trade-in.',
  },
};

// Contains the basic Online Form Lookup but adds in protection plans
// Returns a map of key -> plan name
export const getOnlineFormPackMap = (dealer: Dealer) => {
  const protectionPlanProducts = dealer?.penProducts || [];
  const productEntries = protectionPlanProducts.map((product) => [
    `product-${product.id}`,
    {
      // Display name will usually exist but not always
      name: product.displayName || (product as ProviderProduct).raw.name,
      group: PROTECTION_PLANS_GROUP,
      description: PROTECTION_PLANS_DESCRIPTION,
    },
  ]);
  return { ...ONLINE_FORM_PACK_LOOKUP, ...fromPairs(productEntries) };
};
